// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calc-view[data-v-34a22c30]{margin:40px 0;padding:12px 22px;display:flex;justify-content:center}.calc-view__calc[data-v-34a22c30]{max-width:952px;width:100%}@media(max-width:600px){.calc-view[data-v-34a22c30]{margin:50px 0;padding:10px 15px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
